import React from 'react';
import { Modal, message } from 'antd';
import s from './s.module.less';

interface IProps {
    open: boolean;
    onDismiss: () => void;
    onInterested: () => void;
}

const ManagedBillingModal = ({ open, onDismiss, onInterested }: IProps) => {
    const handleInterested = () => {
        // TODO: call POST /api/users/express-managed-billing-interest once backend is live
        // Backend schema + endpoint pending (tracked with eng team)
        console.log('Managed Billing lead recorded (mocked)');

        message.success('Saved. Our team will reach out about Managed Billing.');
        onInterested();
    };

    return (
        <Modal
            open={open}
            onCancel={onDismiss}
            footer={null}
            width={920}
            centered
            destroyOnClose
            className={s.modalRoot}
        >
            <div className={s.header}>
                <h2>Did you know Klarity can handle insurance billing for you?</h2>
                <p>
                    Automatically submit claims, appeal denials, and track reimbursements after every session.
                    No biller needed.
                </p>
            </div>

            <div className={s.body}>
                <div className={s.statsGrid}>
                    <div className={s.statCard}>
                        <div className={s.statValue}>3.9%</div>
                        <div className={s.statTitle}>Industry-best rate</div>
                        <div className={s.statSub}>Pay only when paid</div>
                    </div>
                    <div className={s.statCard}>
                        <div className={s.statValue}>94%</div>
                        <div className={s.statTitle}>First-pass acceptance</div>
                        <div className={s.statSub}>vs. 70 to 80% industry avg</div>
                    </div>
                    <div className={s.statCard}>
                        <div className={s.statValue}>&lt;24 hr</div>
                        <div className={s.statTitle}>Claim filed same-day</div>
                        <div className={s.statSub}>After every session</div>
                    </div>
                    <div className={s.statCard}>
                        <div className={s.statValue}>0</div>
                        <div className={s.statTitle}>Denials left unworked</div>
                        <div className={s.statSub}>Every denial appealed</div>
                    </div>
                </div>

                <div className={s.sectionTitle}>What&apos;s included</div>

                <div className={s.featureGrid}>
                    <div className={s.featureCard}>
                        <div className={s.featureIconWrap}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="22" y1="2" x2="11" y2="13"></line>
                                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                            </svg>
                        </div>
                        <div className={s.featureText}>
                            <div className={s.featureTitle}>Same-day claim submission</div>
                            <div className={s.featureBody}>
                                Claims filed within 24 hours of every session. No more end-of-week billing backlog.
                            </div>
                        </div>
                    </div>

                    <div className={s.featureCard}>
                        <div className={s.featureIconWrap}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                <polyline points="9 12 11 14 15 10"></polyline>
                            </svg>
                        </div>
                        <div className={s.featureText}>
                            <div className={s.featureTitle}>Automatic denial management &amp; appeals</div>
                            <div className={s.featureBody}>
                                We catch denials, diagnose root causes, and file appeals on your behalf.
                            </div>
                        </div>
                    </div>

                    <div className={s.featureCard}>
                        <div className={s.featureIconWrap}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <polyline points="9 12 11 14 15 10"></polyline>
                            </svg>
                        </div>
                        <div className={s.featureText}>
                            <div className={s.featureTitle}>Insurance eligibility verification</div>
                            <div className={s.featureBody}>
                                Every patient verified before the session so you&apos;re never surprised at payment time.
                            </div>
                        </div>
                    </div>

                    <div className={s.featureCard}>
                        <div className={s.featureIconWrap}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="20" x2="18" y2="10"></line>
                                <line x1="12" y1="20" x2="12" y2="4"></line>
                                <line x1="6" y1="20" x2="6" y2="14"></line>
                            </svg>
                        </div>
                        <div className={s.featureText}>
                            <div className={s.featureTitle}>Billing performance reports</div>
                            <div className={s.featureBody}>
                                On-demand and weekly reports on submissions, collections, denials, and AR.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={s.footer}>
                <button type="button" className={s.skipBtn} onClick={onDismiss}>
                    Skip for now
                </button>
                <button type="button" className={s.primaryBtn} onClick={handleInterested}>
                    Yes, I&apos;d like to learn more later
                </button>
            </div>
        </Modal>
    );
};

export default ManagedBillingModal;